import AuditHistory from '@/components/AuditHistory';
import { useGetUserLogsQuery } from '@/services';

export default function UserManagementHistory() {
    const { data, isLoading, error } = useGetUserLogsQuery();

    return (
        <AuditHistory
            title="User Management History"
            backLink={{ to: '/users', label: 'Back to Users' }}
            data={data}
            isLoading={isLoading}
            error={error}
            emptyMessage="No user management history found."
        />
    );
}
